// Palvelimelta haetun pelitilan muistikopio puhelimessa.
//
// Ilman tätä sovellus näyttäisi offline-käynnistyksessä 0 ruutua ja tyhjän kartan,
// vaikka palvelimella on kaikki tallessa. Kopio on vain NÄYTTÖÄ varten: palvelin on
// totuuslähde, ja seuraava onnistunut haku korvaa kopion.
//
// Kopio kuuluu aina yhdelle pelaajalle (jokaisella on oma kartta). Liian suurta kopiota
// ei tallenneta: localStorage jaetaan retken tallennuksen kanssa, eikä pelitilan
// kopio saa viedä siltä tilaa.

export const MAX_SNAPSHOT_BYTES = 1_000_000;

const key = (player, name) => `snap:${player}:${name}`;

/** Viimeksi tallennettu kopio tai null. */
export function loadSnapshot(storage, player, name) {
  return storage.get(key(player, name), null);
}

/** Tallentaa kopion. Palauttaa false, jos se on liian suuri tai tallennus epäonnistui. */
export function saveSnapshot(storage, player, name, value, maxBytes = MAX_SNAPSHOT_BYTES) {
  if (value === null || value === undefined) return false;
  let size;
  try {
    size = JSON.stringify(value).length; // merkkejä ~ tavuja riittää rajaksi
  } catch {
    return false;
  }
  if (size > maxBytes) {
    storage.remove(key(player, name)); // vanha kopio olisi harhaanjohtavan vanha
    return false;
  }
  return storage.set(key(player, name), value);
}
